module.exports = __webpack_public_path__ + "img/text3.f5d96f13.png";